import deepmerge from 'deepmerge';
import { FragmentConfig } from '@/config/types';
import config from './default';
import { DeepPartial } from './deeppartial';

export const tenantConfig: DeepPartial<FragmentConfig> = {
  apiParams: {
    values: {
      apiDefaultParams: {
        channel: 'web',
        clientId: 'UniversalAt',
        clientShortId: 'uvs',
        locale: 'de-AT',
        localeApi: 'de',
        localesToSwitch: ['de-AT'],
        useNewApi: true,
      },
      apiAssetManagement: {
        path: 'https://media.universal.at',
      },
    },
  },
  headerInformation: {
    de: {
      description:
        'Universal.at - Online Shop für Mode, Möbel, Technik ✓ Gratis 3 Jahre XXL-Garantie ✓ Wunsch-Teilzahlung ✓ Gratis Versand ab EUR 75.- (ausgen. Spedition)',
      title: 'Universal.at | Mode - Möbel - Technik online kaufen',
      canonical: 'https://www.universal.at',
      robots: 'index,follow',
    },
  },
  tracking: {
    schemaOrgOrganisation: {
      areaServed: 'AT',
      email: 'service@universal.at',
      hoursAvailable: '7 Tage die Woche auch an Wochenenden und Feiertagen von 7 - 22 Uhr',
      logo: `/assets/logos/${config?.global?.values?.FRAGMENT_COMPANYID}/logo.svg`,
      name: 'Universal',
      productSupported: '',
      sameAs: [
        '"https://www.pinterest.com/universal1/"',
        '"https://www.facebook.com/UniversalVersand"',
        '"https://www.youtube.com/user/UniversalVersand1"',
      ],
      telephone: '+43-662-4485-8',
      url: 'https://www.universal.at',
      potentialAction: {
        target: 'https://www.universal.at/s/',
      },
    },
    values: {
      googleSiteVerification: 's2QUnwdvTe-7ynyeA5_mieNSFv5fBht-tPHc8U2_BOs',
      msvalidate01: '4067315BE5669CD6C74BDEC6F6AC5D47',
      siteName: '@EmpirieCom-UniversalAT',
      soastaId: 'VCRLH-5E9R4-TT9EZ-675H5-A9TNA',
    },
  },
};

export default deepmerge(config, tenantConfig) as FragmentConfig;
